// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__wNaLk","requiredAsterisk":"Info_requiredAsterisk__1J0-o"};